import React, { useEffect } from "react";
import { siteData } from "../mock";
import { Check, ArrowRight, Sparkles } from "lucide-react";
import FAQ from "../components/FAQ";
import CTASection from "../components/CTASection";
import RelatedArticles from "../components/RelatedArticles";
import SEO from "../components/SEO";
import { PAGE_META } from "../data/pageMeta";

function PricingCard({ item }) {
  return (
    <div
      className={`relative rounded-3xl p-8 border transition-all ${
        item.highlight
          ? "bg-gradient-to-br from-[#c76d4b] to-[#e18b6a] text-white border-transparent shadow-2xl shadow-[#c76d4b]/25"
          : "bg-white text-[#2b2620] border-[#eee5d6]"
      }`}
    >
      {item.highlight && (
        <span className="absolute -top-3 left-1/2 -translate-x-1/2 bg-white text-[#c76d4b] text-xs px-3 py-1 rounded-full uppercase tracking-widest font-semibold border border-[#eee5d6] shadow">
          Recommandé
        </span>
      )}
      <div className="text-xs uppercase tracking-[0.15em] mb-2 opacity-70">{item.duration}</div>
      <h3 className="font-serif text-2xl font-medium mb-4">{item.title}</h3>
      <div className="flex items-baseline gap-2 mb-6">
        <span className="font-serif text-5xl font-medium">{item.price}</span>
        {item.realPrice && (
          <span className="text-sm line-through opacity-60">{item.realPrice}</span>
        )}
      </div>
      <ul className="space-y-3">
        {item.features.map((f) => (
          <li key={f} className="flex items-start gap-2 text-sm">
            <Check size={16} className={item.highlight ? "text-[#d97757] mt-0.5" : "text-[#d97757] mt-0.5"} />
            <span className={item.highlight ? "text-[#e8ddd0]" : "text-[#4a4642]"}>{f}</span>
          </li>
        ))}
      </ul>
      <a
        href="https://www.resalib.fr/praticien/120570-jean-christophe-happillon-fasciatherapeute-quint-fonsegrives"
        target="_blank"
        rel="noreferrer"
        className={`mt-8 w-full inline-flex justify-center items-center gap-2 py-3 rounded-full font-medium text-sm transition-colors ${
          item.highlight
            ? "bg-white text-[#c76d4b] hover:bg-[#fff5ec]"
            : "bg-[#c76d4b] text-white hover:bg-[#e18b6a]"
        }`}
      >
        Réserver <ArrowRight size={14} />
      </a>
    </div>
  );
}

export default function Tarifs() {
  useEffect(() => { window.scrollTo(0, 0); }, []);
  return (
    <>
      <SEO
        {...PAGE_META["/tarifs"]}
        keywords={["tarifs fasciathérapie", "prix coach sportif Toulouse", "crédit d'impôt", "sport à domicile"]}
      />
      <section className="container-tight py-16">
        <div className="max-w-3xl">
          <span className="chip mb-4">Tarifs transparents</span>
          <h1 className="font-serif text-5xl md:text-6xl font-medium text-[#1a1815] tracking-tight leading-[1.05]">
            Choisissez la formule qui vous ressemble
          </h1>
          <p className="mt-5 text-lg text-[#4a4642] leading-relaxed">
            Fasciathérapie et coaching sport santé à domicile à Toulouse. À chaque séance son objectif, sans engagement.
          </p>
          <div className="mt-6 inline-flex items-center gap-2 rounded-full bg-[#f0e4d5] text-[#b85e42] px-4 py-2 text-sm font-medium">
            <Sparkles size={14} /> 50% de réduction immédiate grâce au crédit d'impôt sur le coaching
          </div>
        </div>
      </section>

      <section className="container-tight pb-12">
        <h2 className="font-serif text-3xl font-medium text-[#1a1815] mb-8">Fasciathérapie à domicile</h2>
        <div className="grid md:grid-cols-2 gap-5">
          {siteData.pricing.fasciatherapie.map((p) => <PricingCard key={p.title} item={p} />)}
        </div>
      </section>

      <section className="container-tight py-12">
        <h2 className="font-serif text-3xl font-medium text-[#1a1815] mb-8">Coaching sport santé à domicile</h2>
        <div className="grid md:grid-cols-3 gap-5">
          {siteData.pricing.coaching.map((p) => <PricingCard key={p.title} item={p} />)}
        </div>
        <p className="text-center text-sm text-[#8a8580] mt-8">
          Sans engagement. Annulation gratuite jusqu'à 48h avant la séance.
        </p>
      </section>

      <FAQ />
      <RelatedArticles
        title="Envie d'en savoir plus ?"
        subtitle="Articles du journal bien-être pour comprendre nos approches avant de réserver."
      />
      <CTASection />
    </>
  );
}
